<script setup lang="ts">
const uiStore = useUIStore()
const userStore = useUserStore()
function closeModals() {
  if (userStore.isLoggedIn) {
    uiStore.isShowLoginModal = false
  }
  uiStore.isShowSignUpModal = false
}
</script>

<template>
  <Modal
    :show="uiStore.isShowSignUpModal"
    clear-campaign-on-close
    @close="closeModals"
    class="signup-modal__modal"
    data-testid="signup-modal"
  >
    <RegisterForm @close="closeModals" />
  </Modal>
</template>

<style></style>
